import React, { useContext, useRef, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  MdDashboard,
  MdPerson,
  MdPeople,
  MdSupervisorAccount,
  MdEventNote,
  MdLogout,
  MdClose,
  MdSettingsApplications,
  MdStorefront,
  MdSmartphone,
  MdCardGiftcard,
  MdHistoryEdu,
  MdAssignment,
  MdOutlineImage,
  MdAccountBalanceWallet,
  MdShare,
  MdCallReceived,
  MdCallMade,
  MdChat,
} from "react-icons/md";
import { BsClipboard2Data } from "react-icons/bs";
import { IoWalletSharp } from "react-icons/io5";
import { GiAbstract113 } from "react-icons/gi";
import { ImAddressBook } from "react-icons/im";
import AppLogo from "./AppLogo";
import "../styles/AppLogo.css";
import "../styles/Sidebar.css";
import SettingServices from "../services/SettingServices";
import { FaExchangeAlt } from "react-icons/fa";

const Sidebar = ({ isOpen = false, onClose }) => {
  const { user, logout } = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();
  //   console.log("Sidebar User Role:", user);
  const settingApi = new SettingServices();
  const [settingData, setSettingData] = useState(null);
  useEffect(() => {
    settingApi.getSettingData().then((res) => {
      if (res.isSuccess) {
        setSettingData(res.data);
      }
    });
  }, []);

  const sidebarRef = useRef(null);
  const handleLogout = () => {
    logout();
    history.push("/login");
  };

  const menuItems = [
    {
      label: "Dashboard",
      icon: MdDashboard,
      path: "/dashboard",
      roles: [1, 2, 3, 4, 5],
    },
    {
      label: "Yantra Manage",
      icon: GiAbstract113,
      path: "/yantra-manage",
      roles: [1],
    },
    {
      label: "Yantra Sessions",
      icon: MdEventNote,
      path: "/game-sessions",
      roles: [1],
    },
    {
      label: "Image Template",
      icon: MdOutlineImage,
      path: "/image-template",
      roles: [1, 2],
    },
    {
      label: "Payment Accounts",
      icon: MdAccountBalanceWallet,
      path: "/payment-accounts",
      roles: [1, 2],
    },
    {
      label: "Share Links",
      icon: MdShare,
      path: "/share-links",
      roles: [1],
    },
    {
      label: "Deposit Requests",
      icon: MdCallReceived,
      path: "/deposit-requests",
      roles: [1, 2, 3, 5],
    },
    {
      label: "Withdrawal Requests",
      icon: MdCallMade,
      path: "/withdrawal-requests",
      roles: [1, 2, 3, 5],
    },
    {
      label: "Support Chat",
      icon: MdChat,
      path: "/support-chat",
      roles: [1, 2, 3, 5],
    },    
    {
      label: "Live Sessions",
      icon: MdEventNote,
      path: "/live-session",
      roles: [1],
    },
    {
      label: "Live Sessions",
      icon: MdEventNote,
      path: "/outlet-live-session",
      roles: [3],
    },
    {
      label: "Live Sessions",
      icon: MdEventNote,
      path: "/mobile-live-session",
      roles: [4],
    },
    {
      label: "Admin Users",
      icon: MdPeople,
      path: "/admin-users",
      roles: [1],
    },
    {
      label: "Sub Admins",
      icon: MdSupervisorAccount,
      path: "/sub-admins",
      roles: [1, 2],
    },
    {
      label: "Outlets",
      icon: MdStorefront,
      path: "/outlets",
      roles: [1, 2, 5],
    },
    {
      label: "Mobile Users",
      icon: MdSmartphone,
      path: "/mobile-users",
      roles: [1, 2, 3, 5],
    },
    {
      label: "Manual Winners",
      icon: MdCardGiftcard,
      path: "/manual-winner",
      roles: [1],
    },
    {
      label: "Jackpot",
      icon: MdCardGiftcard,
      path: "/jackpot",
      roles: [1],
    },
    {
      label: "Multi Winner",
      icon: MdCardGiftcard,
      path: "/multi-winner",
      roles: [1],
    },
    {
      label: "Transaction History",
      icon: MdHistoryEdu,
      path: "/transaction-history",
      roles: [1, 2, 3, 4, 5],
    },
    {
      label: "Balance Transfer",
      icon:  FaExchangeAlt,
      path: "/balance-transfer",
      roles: [1, 2, 3, 5],
    },
    {
      label: "Hisab Kitab",
      icon: ImAddressBook,
      path: "/hisab-kitab",
      roles: [1, 2, 3, 5],
    },
    {
      label: "Wallet Manage",
      icon: IoWalletSharp,
      path: "/wallet-manage",
      roles: [1, 2, 5],
    },
    // {
    //   label: "Withdrawal",
    //   icon: GiWallet,
    //   path: "/withdrawal-management",
    //   roles: [1, 2, 3, 4],
    // },
    {
      label: "Place Bet",
      icon: MdAssignment,
      path: "/place-bet-management",
      roles: [3, 4],
    },
    {
      label: "Report",
      icon: BsClipboard2Data,
      path: "/report-manage",
      roles: [1, 2, 3, 5],
    },
    {
      label: "Settings",
      icon: MdSettingsApplications,
      path: "/settings",
      roles: [1],
    },
    {
      label: "My Profile",
      icon: MdPerson,
      path: "/profile",
      roles: [1, 2, 3, 4, 5],
    },
  ];

  // Filter menu items based on user role
  const visibleItems = menuItems.filter((item) =>
    item.roles.includes(user?.role_id),
  );
  const handleScroll = () => {
    if (sidebarRef.current) {
      sessionStorage.setItem("sidebarScroll", sidebarRef.current.scrollTop);
    }
  };

  useEffect(() => {
    const savedScroll = sessionStorage.getItem("sidebarScroll");
    if (savedScroll && sidebarRef.current) {
      sidebarRef.current.scrollTop = Number(savedScroll);
    }
  }, []);

  return (
    <>
      {/* Sidebar */}
      <aside
        ref={sidebarRef}
        onScroll={handleScroll}
        className={`sidebar ${isOpen ? "open" : ""}`}
      >
        {/* Logo - like image 1 */}
        <div className="sidebar-logo">
          <AppLogo showSubtext={true} size="medium" title={settingData?.main_title} subTitle={settingData?.sub_title} />
          {/* Close button (mobile drawer) */}
          <button
            type="button"
            className="sidebar-close-btn"
            onClick={() => onClose && onClose()}
            aria-label="Close menu"
          >
            <MdClose size={22} />
          </button>
        </div>

        {/* Navigation Menu */}
        <nav className="sidebar-nav">
          <ul className="menu-list">
            {visibleItems.map((item) => {
              const Icon = item.icon;
              const isActive =
                location.pathname === item.path ||
                (item.path !== "/" &&
                  location.pathname.startsWith(item.path + "/"));
              return (
                <li key={item.path} className="menu-item">
                  <Link
                    to={item.path}
                    className={`menu-link ${isActive ? "active" : ""}`}
                    onClick={() => onClose && onClose()}
                  >
                    <Icon className="menu-icon" />
                    <span>{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Sidebar Footer */}
        <div className="sidebar-footer">
          {/* Logout Button */}
          <button className="logout-btn" onClick={handleLogout} title="Logout">
            <MdLogout />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={() => onClose && onClose()} />
      )}
    </>
  );
};

export default Sidebar;
